import React, {
  createContext,
  useLayoutEffect,
  useState,
  type ReactNode,
} from 'react';

import { useSafeContext } from '@sunrise-ui/primitives';
import { router, useGlobalSearchParams } from 'expo-router';
import { ConfirmedSessionDetailsModal } from '../components/sessions/ConfirmedSessionDetailsModal';

type SessionModalContextType = {
  sessionId?: string;
  openModal: (sessionId: string) => void;
  closeModal: () => void;
};

// @ts-expect-error -- don't use default, instead console error if component not used in appropriate context
const SessionModalContext = createContext<SessionModalContextType>();

type Props = {
  children: ReactNode;
  isManagerView?: boolean;
};

export function SessionModalProvider({
  children,
  isManagerView = false,
}: Props) {
  const [sessionId, setSessionId] = useState<string>();
  const { sessionId: searchParamSessionId } = useGlobalSearchParams<{
    sessionId?: string;
  }>();

  const openModal = (id: string) => {
    setSessionId(id);
  };

  const closeModal = () => {
    if (searchParamSessionId) router.setParams({ sessionId: undefined });
    setSessionId(undefined);
  };

  // Sync search params with context state
  useLayoutEffect(() => {
    if (
      searchParamSessionId &&
      searchParamSessionId !== 'undefined' &&
      searchParamSessionId !== sessionId
    ) {
      // Search param changed, update context
      setSessionId(searchParamSessionId);
    }
  }, [sessionId, searchParamSessionId]);

  return (
    <SessionModalContext.Provider
      value={{
        sessionId,
        openModal,
        closeModal,
      }}
    >
      {children}
      <ConfirmedSessionDetailsModal
        isManagerView={isManagerView}
        sessionId={sessionId}
        closeModal={closeModal}
      />
    </SessionModalContext.Provider>
  );
}

export function useSessionModal() {
  return useSafeContext(SessionModalContext);
}
